import { getConfigValue } from '../../Providers/ConfigsApi';

export default async function SlashPriceEnabled() {
  const configKey = 'slash-price';

  try {
    const slashPrice = await getConfigValue(configKey);
    return slashPrice.length > 0 && slashPrice[0].toLowerCase() === 'on';
  } catch (err) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/SlashPrice/SlashPriceEnabled.js